/* SAFA · "Finalizar compra" do carrinho lateral -> checkout da Yampi.
   Faz a mesma consulta que o script oficial da Yampi (YampiSnippet) faz na página /cart:
   - Yampi ativa  -> vai direto para o checkout da Yampi (com UTMs), limpando o carrinho Shopify como a Yampi faz.
   - Yampi inativa -> segue para o checkout da Shopify (para não travar a venda).
   - Erro/timeout  -> vai para /cart, onde o próprio script da Yampi assume. */
(function () {
  var ENDPOINT = 'https://api.dooki.com.br/v2/public/shopify/cart';
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function go(state, url) { if (state.done) return; state.done = true; window.location.href = url; }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-scart-checkout]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    btn.dataset.label = btn.textContent;
    btn.textContent = 'Indo para o pagamento…';

    var state = { done: false };
    var fallback = setTimeout(function () { go(state, base + 'cart'); }, 8000);

    fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            shop: window.location.host,
            shopify_internal_domain: (window.Shopify && Shopify.shop) || '',
            cart_payload: cart
          })
        }).then(function (r) { return r.json(); }).then(function (resp) { return { resp: resp || {}, cart: cart }; });
      })
      .then(function (d) {
        clearTimeout(fallback);
        var resp = d.resp;
        if (resp.active && resp.checkout_direct_url) {
          var url = typeof window.ymp_getUrlWithUtms === 'function' ? window.ymp_getUrlWithUtms(resp.checkout_direct_url) : resp.checkout_direct_url;
          var bundles = (d.cart.items || []).some(function (it) { return it.has_components; });
          if (bundles) return go(state, url);
          fetch(base + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
            .then(function () { go(state, url); }, function () { go(state, url); });
        } else {
          go(state, base + 'checkout');
        }
      })
      .catch(function () { clearTimeout(fallback); go(state, base + 'cart'); });
  }, true);

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-scart-checkout][data-busy]').forEach(function (b) {
      b.textContent = b.dataset.label; delete b.dataset.busy;
    });
  });
})();
